import { object } from "../../helpers/object";
import { debug } from "../../helpers/debug";
import { theme } from "../../helpers/theme";
import { utils } from "../../helpers/utils";
import { tpl } from "../../helpers/tpl";

import { comparator } from "./comparator";
import { services } from "../../helpers/service";
import { gtm } from "../../components/gtm";
import { sticky } from "../../components/sticky";

const WLProductSelection = require('../wishlist-manager/modules/wl/WL-product-selection').default;

/*------------------------------------*\
  #COMPARATORPAGE
\*------------------------------------*/
class ComparatorPage {
  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
    this.COUNT = 0;
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;
    // INIT MODULE
    this.initHandler();
    // LISTNER
    document.addEventListener('COMPARATOR_HAS_CHANGER', () => {
      this.show('loader', false);
      setTimeout(() => {
        this.reset();
        this.initHandler(true);
      }, 1500)
    });

    if(debug.DEBUG) console.log('modules/comparator-page.js');
  }
  /**
   * RESET
   */
  reset = () => {
    this.DOM_MODULE[0].querySelectorAll('.m-comparator__item--actif')
      .forEach(element => element.classList.remove('m-comparator__item--actif'));

    this.DOM_MODULE[0].querySelectorAll('[data-js-comparator-line-carac-tech="true"]')
      .forEach(element => element.remove());
  }
  /**
   * INIT HANDLER
   */
  initHandler = (reset) => {
    if (!reset) {
      this.show('loader', true);
    }
  
    const cookieIds = this.cookieGetIds();
    if (!cookieIds || cookieIds.length <= 1) {
      this.show('empty', true);
      return;
    }
  
    services.use(theme.isPro() ? 'comparatorPro' : 'comparator', { refs: cookieIds })
      .then((result) => {
        this.COUNT = result.datas.length;
        const $dataLayerIds = result.datas.map((element, index) => {
          this.generateProduct(element, index);
          return element.ean;
        });
  
        const $dataLayerCount = $dataLayerIds.length;
        this.DOM_MODULE[0].style.setProperty('--comparator-page-items', $dataLayerCount);
  
        gtm.track({
          event: 'productCompared',
          eventCategory: 'Comparator',
          eventAction: 'product_comparison',
          eventLabel: $dataLayerIds.toString(),
          eventValue: $dataLayerCount
        });
  
        this.hideEmptyLine();
        WLProductSelection.init();
        this.show('list', true);
        setTimeout(() => {
          sticky.resizeHandler();
        }, 1000);
      })
      .catch((error) => {
        console.error(error);
        this.show('empty', true);
        console.error('erreur pendant le chargement des refs du comparateur');
      });
  }
  /**
   * GET LINE ELEMENT
   * @param {string} name 
   * @param {number} index 
   * @returns 
   */
  getLineElement = (name, index) => {
    const elements = this.DOM_MODULE[0].querySelectorAll(`.m-comparator__line-${name} .m-comparator__item`);
    return elements[index] || false;
  }
  setElementContent = (selector, index, childTarget, attribute = 'textContent', value) => {
    const element = this.getLineElement(selector, index);
    if (element) {
      element.classList.add('m-comparator__item--actif');
      const child = element.querySelector(childTarget);
      if (child) child[attribute] = value;
    }
  };
  setProductIdAttributes = (selector, index, attribute, value) => {
    const element = this.getLineElement(selector, index);
    if (element) {
      const productIdElements = element.querySelectorAll(`[data-product-${attribute}]`);
      productIdElements.forEach((productIdElement) => {
        productIdElement.setAttribute(`data-product-${attribute}`, value);
      });
    }
  };
  /**
   * GenerateProduct
   * génération front du comparateur
   * @param {json} json 
   * @param {int} index 
   */
  generateProduct = (json, index) => {
    for (var key of Object.keys(json)) {
      let value = json[key];
      if( value === "" ) value = "-";

      switch (key) {
        case 'media':
          this.setElementContent('image', index, 'img', 'src', 'https://www.legrand.fr' + value);
          break;
        case 'price':
          this.setElementContent('price', index, '.c-product-price__value', 'textContent', value);
          break;
        case 'ean':
          this.setProductIdAttributes('image', index, 'id', value);
          break;
        case 'difficulte':
          const element = this.getLineElement('difficulty', index);
          if (element) {
            element.classList.add('m-comparator__item--actif');
            if (value > 0){
              const stars = element.querySelectorAll('.c-stars__item');
              stars.forEach((star, index) => {
                if (index < value) star.classList.add('c-text--theme');
              });
            } else {
              element.textContent = '-';
            }
          }
          break;
        case 'href':
          this.setElementContent('image', index, '.m-comparator__cta-product', 'href', value);
          break;
        case 'gamme':
          this.setElementContent('range', index, 'a', 'textContent', value);
          break;
        case 'gamme-href':
          this.setElementContent('range', index, 'a', 'href', value);
          break;
        case 'categorie':
          this.setElementContent('category', index, 'a', 'textContent', value);
          this.setProductIdAttributes('image', index, 'cat', value);
          break;
        case 'categorie-link':
          this.setElementContent('category', index, 'a', 'href', value);
          break;
        case 'name':
          this.setElementContent('name', index, 'span', 'textContent', value);
          this.setProductIdAttributes('image', index, 'name', value);
          break;
        case 'caracteristiques':
          this.generateCaracteristiquesTech(json.caracteristiques, index);
          break;
        default:
          this.setElementContent(key, index, 'span', 'textContent', value);
          break;
      }
    }
  }

  generateCaracteristiquesTech = (caracteristiques, index) => {
    if (!caracteristiques || typeof caracteristiques !== 'string') {
      return;
    }

    try {
      const caracArray = JSON.parse(caracteristiques);
      const list = this.DOM_MODULE[0].querySelector('[data-js-comparator-list]');
      
      caracArray.forEach(item => {
        const [id, label, value, unit] = item;
        
        if (value && value !== '') {
          const displayValue = unit && unit !== '' ? `${value} ${unit}` : value;
          const slug = utils.slug(label);
          
          if (this.getLineElement(slug, index)) {
            this.setElementContent(slug, index, 'span', 'innerHTML', displayValue);
          } else {
            const line = tpl.get({label, id: slug}, 'tpl-comparator-line');
            list.insertAdjacentHTML('beforeend', line);
            for (let i = 0; i < this.COUNT; i++) {
              this.setElementContent(slug, i, 'span', 'innerHTML', i === index ? displayValue : '-');
            }
          }
        }
      });
    } catch (e) {
      console.error('Error parsing caracteristiques:', e);
    }
  }
  /**
   * Hides empty lines in the comparator module.
   * 
   * This function iterates through all lines with the class `m-comparator__line` 
   * within the first element of `this.DOM_MODULE`. For each line, it checks if 
   * all items with the class `m-comparator__item m-comparator__item--actif` 
   * have a text content that is just a hyphen ('-'). If a line is found to be 
   * empty (i.e., all such items contain only a hyphen), the line is removed 
   * from the DOM.
   */
  hideEmptyLine = () => {
    const lines = this.DOM_MODULE[0].querySelectorAll('.m-comparator__line');
    lines.forEach(line => {
      const isEmpty = Array.from(line.querySelectorAll('.m-comparator__item.m-comparator__item--actif'))
                           .every(item => item.textContent.trim() === '-');
      if (isEmpty) line.remove();
    });
  };
  /**
   * COOKIE GET IDS
   * @returns 
   */
  cookieGetIds = () => {
    // url /catalogue/comparateur?refs=3414972443586&refs=3414972443227
    const sPageURL = new URLSearchParams(window.location.search);
    const cookieIds = sPageURL.has('refs') ? sPageURL.getAll('refs') : comparator.cookieGetIds();
    return cookieIds;
  }
  /**
   * SHOW
   * @param {string} part 
   * @returns 
   */
  show = (part, heightRefresh) => {
    const partElement = this.DOM_MODULE[0].querySelector(`.m-comparator__${part}`);
    if (!partElement) return;
    
    if (heightRefresh) {
      setTimeout(() => {
        let targetHeight = partElement.offsetHeight;
        this.DOM_MODULE[0].style.setProperty('--comparator-page-height', `${targetHeight}px`);
        this.DOM_MODULE[0].setAttribute('data-js-comparator-page', part);
      }, 1500)
    } else {
      this.DOM_MODULE[0].setAttribute('data-js-comparator-page', part);
    }
  }
}
export const comparatorPage = new ComparatorPage('[data-js-component="comparator-page"]'); 